console.log("Photos controller loading - version 1")

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "placeholder"]

  connect() {
    console.log("Photos controller connected")
    if ("IntersectionObserver" in window) {
      this.setupIntersectionObserver()
    }
  }

  imageLoaded(event) {
    const img = event.target
    img.classList.remove('opacity-0')
    
    // Remove blur placeholder after full image loads
    const placeholder = img.parentElement.querySelector('[data-photos-target="placeholder"]')
    if (placeholder) {
      placeholder.classList.add('opacity-0')
      setTimeout(() => placeholder.remove(), 300) // Remove from DOM to free memory
    }
  }

  placeholderLoaded(event) {
    const placeholder = event.target
    placeholder.classList.remove('opacity-0')
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '100px', // Increased margin for smoother loading
      threshold: 0.1
    }

    this.observer = new IntersectionObserver(this.debounce((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadImage(entry.target)
          this.observer.unobserve(entry.target) // Stop observing after image loads
        }
      })
    }, 100), options) // Debounce to prevent rapid execution

    this.imageTargets.forEach(img => {
      this.observer.observe(img)
    })
  }

  loadImage(img) {
    if (!img.dataset.src) return

    // Use requestIdleCallback to defer loading if the browser is busy
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => this.processImage(img))
    } else {
      this.processImage(img)
    }
  }

  processImage(img) {
    const placeholder = this.placeholderTargets[this.imageTargets.indexOf(img)]
    const fullImage = new Image()

    fullImage.onload = () => {
      img.src = fullImage.src
      img.classList.remove('opacity-0')

      if (placeholder) {
        placeholder.classList.add('opacity-0')
        setTimeout(() => placeholder.remove(), 300)
      }
    }

    // Use srcset for responsive images
    fullImage.srcset = img.dataset.srcset || ""
    fullImage.src = img.dataset.src
  }

  // Debounce function to limit rapid calls
  debounce(func, wait) {
    let timeout
    return function(...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }
}

